export * from "./statuses";

export function sharedHello(): string {
  return "shared ready";
}
